import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import LuigiClient from '@luigi-project/client';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Grid from '@mui/material/Grid';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { getStoreData } from '../../../services/store-service';
import StorePickerSettings from './StorePickerSettings';

export default function StorePicker(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState();
  const [store, currentStore] = React.useState({
    storeName: '',
    storeNumber: '',
  });
  const [stores, setStores] = useState([]);

  const fetchStores = useCallback(async () => {
    try {
      const response = await getStoreData();
      const data = await response;
      const transformStores = data.sort((a, b) => {
        return a.storeNumber > b.storeNumber
          ? 1
          : a.storeNumber < b.storeNumber
          ? -1
          : 0;
      });
      currentStore({
        storeName: transformStores[0].storeName,
        storeNumber: transformStores[0].storeNumber,
      });
      controlPointSend('store.change', transformStores[0].storeNumber);
      setStores(transformStores);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchStores();
  }, [fetchStores]);

  const handleClick = newPlacement => event => {
    setAnchorEl(event.currentTarget);
    setOpen(prev => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };
  const handleClickAway = () => {
    setOpen(false);
  };
  const storeChange = storeObj => {
    currentStore({
      storeName: storeObj.storeName,
      storeNumber: storeObj.storeNumber,
    });
    handleClickAway();
  };
  const controlPointSend = (msgType, payload) => {
    LuigiClient.setTargetOrigin(window.location.origin);

    LuigiClient.sendCustomMessage({
      id: 'controlpoint.send',
      value: {
        id: msgType,
        value: payload,
      },
    });
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box className="storePicker" sx={{ width: 500 }}>
        <Popper
          className="cfa-store-popper"
          open={open}
          anchorEl={anchorEl}
          placement={placement}
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <section className="store-picker-container">
                  {stores.length > 0 && (
                    <StorePickerSettings
                      stores={stores}
                      onSelectStore={storeChange}
                      currentStore={store}
                    />
                  )}
                </section>
              </Paper>
            </Fade>
          )}
        </Popper>
        <Grid container justifyContent="center">
          <Grid item>
            <div
              className="col align-self-center text-center text-lg-right ellipse-overflow"
              onClick={handleClick('bottom')}
            >
              {store.storeName.length > 0 && (
                <span>
                  {store.storeNumber} • {store.storeName}
                </span>
              )}
            </div>
            {store.storeName.length > 0 && (
              <ArrowDropUpIcon
                className={
                  open ? 'cfa-arrow' : 'cfa-arrow cfa-store-select-icon rotate'
                }
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </ClickAwayListener>
  );
}
